/* @flow */
import { List } from 'immutable';
import jstz from 'jstz';

export const SUBMIT_ENDPOINT = '/services/incident-reports';

export const UPLOAD_ENDPOINT = '/services/extract';

export const INDICATORS_ENDPOINT = '/services/create/submit-iocs';
export const INDICATORS_FILE_ENDPOINT = `${INDICATORS_ENDPOINT}-file`;

// Java apparently has some non-standard, lame date parsing capabilities:
// https://docs.oracle.com/javase/8/docs/api/java/time/format/DateTimeFormatter.html#ISO_ZONED_DATE_TIME
export const JAVA_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

// Max length in characters of the report subject
export const MAX_SUBJECT_LENGTH = 300;

const currentTimezone = jstz.determine().name();

export const INITIAL_FORM_VALUES = {
  title: '',
  distributionType: 'ENCLAVE',
  shouldEmailReportToThirdParty: false,
  enclaveGuid: null,
  timeBegan: null,
  timeBeganTimezone: currentTimezone,
  timeBeganUnknown: false,
  sector: null,
  tags: List(),
  content: {
    name: '',
    size: null,
    type: null,
    data: '',
  },
};

export const INITIAL_INDICATORS_FORM_VALUES = {
  enclaves: null,
  tags: List(),
  content: {
    name: '',
    size: null,
    type: null,
    data: '',
  },
};

export const SPREADSHEET = 'SPREADSHEET';
export const FILE = 'FILE';
export const TEXT = 'TEXT';

export type SubmissionType = typeof SPREADSHEET | typeof FILE | typeof TEXT;

// Accepted file types for upload
export const acceptedFilesTypes = [
  'text/*',
  '.csv',
  '.json',
  '.pdf',
  '.xml',
  '.stix',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.eml',
  '.msg',
].join(',');

// Accepted file types for upload
export const acceptedImageTypes = [
  '.jpg',
  '.png',
  '.jpeg',
].join(',');

// Accepted icon image types for upload - SVG
export const acceptedSourceIconImageTypes = [
  '.svg',
].join(',');

// Max image file size in bytes (set to 2 MB)
export const maxFileSize = 2 ** 20;

export const acceptedFilesTypesSpreadsheet = [
  '.csv',
  '.xls',
  '.xlsx',
].join(',');



// WEBPACK FOOTER //
// ./src/app/modules/create/constants.js